<!-- 志扬文化 -->
<template>
  <div class="frame">
    <img
      src="http://api.zyzxgc.cn/file/static/banner_culture.jpg"
      class="banner"
    />
    <div class="wrap">
      <div class="box">
        <div class="title-box">
          <div class="point"></div>
          <div class="title">logo诠释</div>
          <div class="en">LOGO INTERPRETATION</div>
        </div>
        <div class="intro">
          <div class="left">
            志扬logo诠释（logo见右图）：志扬的LOGO以“志”为出发点，意为心怀家国、志诚于心、发扬蹈厉、行稳致远；下半部形似帆船，意为锐意进取、乘风破浪、扬帆远航；图形整体形似一枚印章，以诠释志扬的诚信、责任、担当、专业精神。
          </div>
          <img src="../assets/logo.png" alt="logo" class="logo" />
        </div>
        <div class="way-box">
          <img
            src="http://api.zyzxgc.cn/file/static/culture_img1.png"
            class="post"
          />
          <div class="way">
            <sub-title
              title="「合」之道"
              en='THE WAY OF "COMBINING"'
              theme="white"
            ></sub-title>
            <div class="line"></div>
            <div class="desc">
              「合」之道：合者，与国家合、与时代合、与政策合、与行业合、与客户合、与员工合、
              与自然合……
            </div>
          </div>
        </div>
      </div>
      <div class="box">
        <div class="title-box">
          <div class="point"></div>
          <div class="title">使命·愿景·价值观</div>
          <div class="en">MISSION·VISION·VALUES</div>
        </div>
        <div class="list">
          <div class="item">
            <div class="info">
              <div class="in">
                <div class="info-title-box">
                  <div class="title">使命</div>
                  <div class="en">MISSION</div>
                  <div class="line"></div>
                </div>
                <div class="value">
                  <div class="special">匠心咨询 成就匠心建筑</div>
                </div>
              </div>
            </div>
            <img
              src="http://api.zyzxgc.cn/file/static/mission.png"
              class="img"
            />
          </div>
          <div class="item">
            <div class="info">
              <div class="in">
                <div class="info-title-box">
                  <div class="title">愿景</div>
                  <div class="en">VISISON</div>
                  <div class="line"></div>
                </div>
                <div class="value">
                  <div class="special tx1">成为值得信赖的</div>
                  <div class="special tx2">工程咨询顾问服务品牌</div>
                </div>
              </div>
            </div>
            <img
              src="http://api.zyzxgc.cn/file/static/vision.png"
              class="img"
            />
          </div>
          <div class="item">
            <div class="info">
              <div class="in last">
                <div class="info-title-box">
                  <div class="title">价值观</div>
                  <div class="en">VALUES</div>
                  <div class="line"></div>
                </div>
                <div class="value">
                  <div class="special">立信立志</div>
                  <div>有信念 有追求 有目标 有承诺 有担当</div>
                  <div class="special">正道成功</div>
                  <div>正念 正心 正言 正行 正果</div>
                  <div class="special">尚善阳光</div>
                  <div>崇尚仁心向善德行 让自己成为照亮温暖他人的灯塔</div>
                  <div class="special">匠心品质</div>
                  <div>严谨 精益求精 成就精典品质超越客户的期待 感动客户</div>
                  <div class="special">持续精进</div>
                  <div>每天进步一点点 不断超越昨天的自己</div>
                  <div class="special">共创共赢</div>
                  <div>互助 互补 协同一致 共创价值 共享利益 实现共同的目标</div>
                </div>
              </div>
            </div>
            <img
              src="http://api.zyzxgc.cn/file/static/values.png"
              class="img"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Store } from "@/store/index.js";
import { mapState } from "pinia";
import SubTitle from "@/components/subTitle.vue";
export default {
  components: { SubTitle },
  data() {
    return {
      routerHistory: [], // 当前所在位置
      subNavs: [],
    };
  },
  computed: {
    ...mapState(Store, ["navList"]),
  },
  created() {
    this.formatBreadCrumb();
  },
  mounted() {},
  methods: {
    // 格式化导航条和二级导航栏
    formatBreadCrumb() {
      let nav = this.navList.find(
        (ele) => ele.path != "/" && this.$route.path.includes(ele.path)
      );
      if (nav.subs && nav.subs.length != 0) {
        // 二级导航栏
        this.subNavs = nav.subs;
      }
      this.routerHistory = [{ path: "/", name: "首页" }, nav];
    },
  },
};
</script>

<style lang="scss" scoped>
.frame {
  .banner {
    width: 100%;
    display: block;
  }
  .wrap {
    background-image: url("http://api.zyzxgc.cn/file/static/culture_bg.png");
    background-size: cover;
    background-position-x: center;

    &::before,
    &::after {
      content: "";
      display: table;
    }

    .box {
      margin: 60px 0 80px;

      .title-box {
        margin-bottom: 20px;
        text-align: center;

        .point {
          width: 27px;
          height: 27px;
          background-color: #a01b1b;
          transform: rotate(45deg);
          margin: 0 auto 25px;
        }
        .title {
          font-size: 44px;
          color: #454545;
          margin-bottom: 15px;
        }
        .en {
          font-size: 18px;
          color: #454545;
        }
      }

      .intro {
        width: 960px;
        margin: 0 auto;
        display: flex;
        justify-content: space-between;
        align-items: center;

        .left {
          width: 750px;
          font-size: 15px;
          color: #5e5d5d;
          line-height: 30px;
        }
        .logo {
          width: 140px;
        }
      }

      .way-box {
        margin-top: 60px;
        display: flex;
        align-items: center;

        .post {
          width: 50vw;
        }
        .way {
          flex-grow: 1;
          background-color: $theme;
          padding: 100px 0 100px 100px;
          box-sizing: border-box;
          color: #fff;

          .line {
            width: 400px;
            margin: 0 0 40px;
          }
          .desc {
            width: 300px;
            font-size: 15px;
            line-height: 30px;
          }
        }
      }
      .list {
        margin-top: 70px;

        .item {
          display: flex;

          &:nth-child(2n) {
            flex-direction: row-reverse;

            .info {
              justify-content: flex-start;
            }
          }

          .info {
            flex-grow: 1;
            padding: 0 70px;
            box-sizing: border-box;
            display: flex;
            justify-content: flex-end;
            align-items: center;

            .in {
              width: 500px;
              text-align: center;

              .info-title-box {
                position: relative;

                .title {
                  font-size: 40px;
                  color: #063c83;
                  font-weight: bold;
                }
                .en {
                  font-size: 42px;
                  color: #063c83;
                  opacity: 0.25;
                  position: absolute;
                  left: 50%;
                  top: -10px;
                  transform: translateX(-50%);
                }
                .line {
                  width: 78px;
                  height: 5px;
                  background-color: #5e5d5d;
                  margin: 50px auto 0;
                }
              }
              .value {
                margin-top: 60px;
                font-size: 36px;
                color: #5e5d5d;

                div {
                  font-size: 20px;
                }
                .special {
                  font-size: 36px;
                  font-family: "pmzd";
                }
                .tx1 {
                  transform: translateX(-100px);
                }
                .tx2 {
                  transform: translateX(100px);
                }
              }
            }

            .last {
              .info-title-box .line {
                margin-top: 10px;
              }
              .value {
                margin-top: 10px;
              }
            }
          }
          .img {
            width: 50%;
          }
        }
      }
    }
  }
}

@media (max-width: 1350px) {
  .frame .wrap .box .list .item .info {
    padding: 10px 30px;

    .in {
      width: 400px;

      .info-title-box .line {
        margin-top: 20px;
      }

      .value {
        margin-top: 30px;

        div {
          font-size: 16px;
        }
        .special {
          font-size: 25px;
        }
      }
    }
  }
}

@media (max-width: 750px) {
  .frame {
    .wrap {
      .box {
        margin: 20px 0 30px;

        .title-box {
          margin-bottom: 15px;

          .point {
            width: 18px;
            height: 18px;
            margin-bottom: 10px;
          }
          .title {
            font-size: 30px;
            margin-bottom: 10px;
          }
          .en {
            font-size: 14px;
          }
        }
        .intro {
          width: 100%;
          flex-direction: column;

          .left {
            width: 100%;
            padding: 0 10px;
            box-sizing: border-box;
            text-indent: 2em;
          }
          .logo {
            width: 160px;
            margin-top: 10px;
          }
        }
        .way-box {
          margin-top: 40px;
          flex-direction: column-reverse;

          .way {
            padding: 20px;

            .line {
              width: 100px;
            }
            .desc {
              width: 100%;
            }
          }
          .post {
            width: 100%;
          }
        }
        .list {
          margin-top: 40px;

          .item {
            & + .item {
              margin-top: 20px;
            }
            .img {
              display: none;
            }
            .info {
              padding: 10px;

              .in {
                width: 100%;

                .info-title-box {
                  .title {
                    font-size: 25px;
                  }
                  .en {
                    font-size: 20px;
                  }
                  .line {
                    width: 40px;
                    height: 2px;
                    margin-top: 10px;
                  }
                }
                .value {
                  div {
                    font-size: 14px;
                    margin-bottom: 5px;
                  }
                  .tx1 {
                    transform: translateX(-58px);
                  }
                  .tx2 {
                    width: 300px;
                    transform: translateX(58px);
                  }
                  .special {
                    font-size: 20px;
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
</style>
